import { Component, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { AuthService } from '../../services/login/auth.service'
import { Router } from '@angular/router'
import { Title } from '@angular/platform-browser'
import { GroupService } from '../../services/group/group.service'
import { ProfileService } from '../../services/profile/profile.service'
import { Profile } from '../../models/users.interface'

@Component({
    selector: 'app-home',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './home.component.html',
    styleUrl: './home.component.css',
})
export class HomeComponent implements OnInit {
    profile: Profile | null = null
    grupoLogueado: string | null = null
    constructor(
        private authService: AuthService,
        private router: Router,
        private title: Title,
        private profileService: ProfileService,
        private groupService: GroupService
    ) {
        this.title.setTitle('Inicio')
    }

    ngOnInit(): void {
        this.profileService.userProfile$.subscribe((profile) => {
            this.profile = profile
            this.grupoLogueado = this.groupService.getFirstGroup(profile)
        })
    }

    logout() {
        this.authService.logout()
        this.router.navigate([''])
    }

    get appTitle(): string {
        if (this.grupoLogueado === 'observatorio')
            return 'Sistema de gestión de incidentes de violencia contra la mujer - Observatorio'
        if (this.grupoLogueado === 'madeja')
            return 'Sistema de gestión de incidentes - Madeja'
        return 'Sistema de gestión de incidentes'
    }
}
